<template lang="pug">
div
    v-dialog(v-model="isShowModal_" @close="isShowModal_=false" width="1000")
        v-card
            v-card-title(class="elevation-1") 
                v-row
                    v-col(cols="11" sm="11" md="11")
                         h5 AGRUPACION: {{InfoGroup.Name}}, CATEGORIA: {{InfoGroup.NameCategory}}
                    v-col(cols="1" sm="1" md="1")
                        v-btn(icon @click="isShowModal_=false")   
                            v-icon mdi-close
            v-container( fluid)    
                v-row
                    v-col(cols="12" sm="12" md="4") 
                        v-text-field(v-model="parameterInsert.Question"
                                label="Pregunta"
                                placeholder="Pregunta"
                                outlined
                                hide-details="auto" 
                                @keypress.enter="Insert()" 
                                )    
                    v-col(cols="12" sm="12" md="5") 
                        v-text-field(v-model="parameterInsert.Description"
                                label="Descripción"
                                placeholder="Descripción"
                                outlined
                                hide-details="auto" 
                                @keypress.enter="Insert()" 
                                )                         
                    v-col(cols="3" sm="12" md="3") 
                        v-btn(color="primary" @click="Insert()" block) ADD 
                            i.fa.fa-plus   
            v-container( fluid)
                v-simple-table(class="elevation-5" )
                            thead(class="elevation-1"  )
                                tr
                                    th Editar
                                    th N°
                                    th Pregunta 
                                    th Descripción  
                                    th Valor
                                    th Estado                       
                            draggable(:list="tableInfo" tag="tbody" @change="eventoChange") 
                                tr(v-if="tableInfo.length", v-for="(item,index) in tableInfo", :key="index")
                                    td
                                        button.btn.btn-sm.btn-info(v-if="item.Update==0", @click="item.Update = 1")     
                                            i.fa.fa-edit  
                                        button.btn.btn-sm.btn-warning(v-else, @click="item.Update = 0; Update(item)")     
                                            i.fa.fa-floppy-o
                                    td {{index+1}}
                                    td
                                        div(v-if="item.Update == 0") {{item.Question}} 
                                        input.form-control.form-control-sm(v-else,v-model="item.Question", :readonly="item.Update==0 ? true:false")
                                    td
                                        div(v-if="item.Update == 0") {{item.Description}} 
                                        input.form-control.form-control-sm(v-else,v-model="item.Description", :readonly="item.Update==0 ? true:false")  
                                    td
                                        div(v-if="item.Update == 0") {{ getTypeName(item.Type) }} 
                                        select.form-control.form-control-sm(v-else, v-model="item.Type" , :disabled="item.Update==0 ? true:false")
                                            option(value=0) SI-NO-N/A
                                            option(value=1) 1-2-3-4-5  
                                            option(value=2) BUENO-MALO-REGULAR-N/A  
                                            option(value=3) Bajo-Próximo-Esperado-Destacado-Sobresaliente
                                            option(value=4) CONOCE-NO CONOCE-N/A
                                            option(value=5) CAMBIO REALIZADO-CAMBIO PENDIENTE-N/A
                                            option(value=6) REVISIÓN-LIMPIEZA/LUBRICA-AJUSTE-CAMBIO-NADA
                                            option(value=7) MENOR-MAYOR-CRITICO
                                            option(value=8) SI-NO
                                            option(value=9) SI CUMPLE-MENOR-MAYOR-CRITICO
                                            option(value=10) APROBADO SIN OBSERVACIONES-APROBADO CON OBSERVACIONES
                                    td  
                                        div(v-if="item.Update == 0") {{item.Active==1 ? 'Activo':'Inactivo'}}
                                        select.form-control.form-control-sm(v-else, v-model="item.Active" , :disabled="item.Update==0 ? true:false")
                                            option(value=1) Activa
                                            option(value=0) Inactiva                        
                  
</template>
<script>
import draggable from "vuedraggable";
import modal from "../../../../../complementos/modal.vue" 
import model from "../../../../../models/docQuestions.js"  
export default {
    props:{  
        IsShowModal:Boolean,
        InfoGroup:Object, 
        apiWeb:Object
    },  
    data(){
        return{
            nameModulo:'',
            pathApi:'DocQuestions/DocQuestions', 
            parameterUpdate:Object.assign({}, model.parameterUpdate),
            parameterInsert:Object.assign({}, model.parameterInsert),
            parameterView:Object.assign({}, model.parameterView), 
            tableInfo:[],
            parameters:{IdDocQuestionTarget:-1,
                            IdDocQuestion:-1}
        }
    },
    mounted(){ 
    },
    components:{
        modal,
        draggable
    },
    computed:{
        isShowModal_ :{
                        get(){
                            this.List_Info()  
                            return this.IsShowModal 
                        },
                        set(val){
                            this.List_Info()  
                            this.$emit("update:IsShowModal",val)
                        }        
        } 
    },
    mounted(){
       this.List_Info()
    },
    methods:{
        getTypeName(type){
            switch (type){
                case 0 :
                    return "SI-NO-N/A"
                case 1 :
                    return "1-2-3-4-5"
                case 2 : 
                    return "BUENO-MALO-REGULAR-N/A"
                case 3 :
                    return "Bajo-Próximo-Esperado-Destacado-Sobresaliente"
                case 4 :
                    return "CONOCE-NO CONOCE-N/A"
                case 5 :
                    return "CAMBIO REALIZADO-CAMBIO PENDIENTE-N/A"
                case 6 :
                    return "REVISIÓN-LIMPIEZA/LUBRICA-AJUSTE-CAMBIO-NADA"
                case 7 :
                    return "MENOR-MAYOR-CRITICO"
                case 8 :
                    return "SI-NO"
                case 9 :
                    return "SI CUMPLE-MENOR-MAYOR-CRITICO"
                case 10 :
                    return "APROBADO SIN OBSERVACIONES-APROBADO CON OBSERVACIONES" 
                default :
                    return "???"
            }             
                         

        },
        eventoChange(event){
            console.log(event.moved.element)
            console.log(event.moved.element.IdDocQuestion)
            console.log(event.moved.newIndex+1)
            console.log(event.moved.oldIndex+1)
                var _idDocQuestion=event.moved.element.IdDocQuestion
                var indexNew=(event.moved.newIndex+1)
                var indexOld=(event.moved.oldIndex+1)
                
                this.parameters.IdDocQuestion=_idDocQuestion

                if(indexNew<indexOld){
                    this.parameters.IdDocQuestionTarget=this.tableInfo[indexNew].IdDocQuestion         
                }                    
                if(indexNew>indexOld){
                    this.parameters.IdDocQuestionTarget=this.tableInfo[indexNew-2].IdDocQuestion
                }                
                 
                 this.apiWeb.post(this.pathApi + "_ChangeOrder",this.parameters)
                    .then(result=>{
                                if(result.status==0){
                                     this.List_Info()
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        List_Info(){  
            this.parameterView.IdDocQuestionsCategory=this.InfoGroup.IdDocQuestionsCategory
          
            this.apiWeb.post(this.pathApi + "_View",this.parameterView)
                    .then(result=>{
                                if(result.status==0){
                                    this.tableInfo=JSON.parse(result.value)                                     
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        }, 
        Insert(){ 
            if(this.validate(this.parameterInsert)){
                this.parameterInsert.IdDocQuestionsCategory=this.InfoGroup.IdDocQuestionsCategory
                this.parameterInsert.User=this.$info.email 
                this.parameterInsert.IP=this.$info.ip
                this.apiWeb.post(this.pathApi +"_Insert",this.parameterInsert)
                        .then(result=>{ 
                                if(result.status==0){
                                    this.List_Info()
                                    this.parameterInsert=Object.assign({}, model.parameterInsert)
                                    this.$emit("change") 
                                    this.$msgbox.show("Ingresado","Notificacion")
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                    this.List_Info()
                                }

                        })
                        .catch(ex=>{
                                    this.$msgbox.show(ex.message,"Error nivel 2")
                                    this.List_Info()})
            }
            
        },
        Update(item){ 
            this.parameterUpdate.Question=item.Question 
            this.parameterUpdate.Description=item.Description ==null ?'': item.Description
            this.parameterUpdate.Type=item.Type
            this.parameterUpdate.Active=item.Active  
            this.parameterUpdate.IdDocQuestion=item.IdDocQuestion
            this.parameterUpdate.IdDocQuestionsCategory=item.IdDocQuestionsCategory
            if(this.validate(this.parameterUpdate)){                
                this.parameterUpdate.User=this.$info.email
                this.parameterUpdate.IP=this.$info.ip
                this.apiWeb.post(this.pathApi + "_Update",this.parameterUpdate)
                        .then(result=>{ 
                                if(result.status==0){
                                    this.List_Info()
                                    this.IsShowModalUpdate=false
                                    this.$emit("change")
                                    this.$msgbox.show("Actualizado","Notificacion")
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                     this.List_Info()
                                }
                        })
                        .catch(ex=>{
                                    this.$msgbox.show(ex.message,"Error nivel 2")
                                    this.List_Info()})
            }
        },
        validate(parameter){ 
            if(parameter.Question=='' || parameter.Question==null ){
                this.$msgbox.show("Ingrese Pregunta","Alerta")
                return false
            }                    
            else{
                return true
            }
        }
    }

    
}
</script>